/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = New
 *
 * 2 = Active
 *
 * 3 = Pause
 *
 * 4 = Suspend
 *
 * 5 = Completed
 */
export enum ClockingStatus {
  New = 1,
  Active = 2,
  Pause = 3,
  Suspend = 4,
  Completed = 5,
}
